import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    border: `1px solid ${idsTokens.card.default.color.border.enabled}`,
    boxShadow: '0px 8px 16px 0px rgba(0, 0, 0, 0.04)',
    paddingTop: idsTokens.card.default.spacing.padding.top,
    paddingRight: idsTokens.card.default.spacing.padding.right,
    paddingBottom: idsTokens.card.default.spacing.padding.bottom,
    paddingLeft: idsTokens.card.default.spacing.padding.left,
    gap: idsTokens.card.default.spacing.padding.gap,
    borderRadius: idsTokens.card.default.radius,
    background: idsTokens.card.default.color.container.enabled,

    '&:focus-visible': {
      outline: `${idsTokens.functional.borderWidth.focus.default} solid ${idsTokens.functional.color.border.focus}`,
      outlineOffset: 1,
    },

    '& .MuiCardActionArea-root': {
      border: `1px solid ${idsTokens.card.default.color.border.enabled}`,

      '&:hover': {
        boxShadow: '0px 8px 16px 0px rgba(0, 0, 0, 0.04)',
        background: idsTokens.card.default.color.container.hover,
        border: `1px solid ${idsTokens.card.default.color.border.hover}`,
        '& .MuiCardHeader-title': {
          color: idsTokens.card.default.color.label.hover,
        },
        '& .MuiCardHeader-subheader': {
          color: idsTokens.card.default.color.sublabel.hover,
        },
      },
    },

    '& .MuiCardHeader-root': {
      paddingTop: idsTokens.card.default.spacing.header.content.padding.top,
      paddingRight: idsTokens.card.default.spacing.header.content.padding.right,
      paddingBottom: idsTokens.card.default.spacing.header.content.padding.bottom,
      paddingLeft: idsTokens.card.default.spacing.header.content.padding.left,
      gap: idsTokens.card.default.spacing.header.content.padding.gap,
      alignItems: 'center',
    },
    '& .MuiCardHeader-title': {
      color: idsTokens.card.default.color.label.enabled,
      fontSize: idsTokens.typography.font.size.base,
      fontWeight: idsTokens.typography.font.weight.bold,
    },
    '& .MuiCardHeader-subheader': {
      color: idsTokens.card.default.color.sublabel.enabled,
      fontSize: idsTokens.typography.font.size.sm,
    },
    '& .MuiCardContent-root': {
      paddingTop: idsTokens.card.default.spacing.body.content.padding.top,
      paddingRight: idsTokens.card.default.spacing.body.content.padding.right,
      paddingBottom: idsTokens.card.default.spacing.body.content.padding.bottom,
      paddingLeft: idsTokens.card.default.spacing.body.content.padding.left,
      gap: idsTokens.card.default.spacing.body.content.padding.gap,
      color: idsTokens.card.default.color.label.enabled,
      fontSize: idsTokens.typography.font.size.base,
    },
    // Card footer styles
    '& .MuiCardActions-root:not(.horizontal-card)': {
      paddingTop: idsTokens.card.default.spacing.footer.padding.top,
      paddingRight: idsTokens.card.default.spacing.footer.padding.right,
      paddingBottom: idsTokens.card.default.spacing.footer.padding.bottom,
      paddingLeft: idsTokens.card.default.spacing.footer.padding.left,
      marginLeft: 'unset',
      gap: idsTokens.card.default.spacing.footer.padding.gap,
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
      '& > div': {
        width: '100%',
        '& .MuiButtonBase-root': {
          width: '50%',
          '&.MuiButton-text.MuiButton-colorPrimary': {
            border: `1px solid ${idsTokens.button.default.color.secondary.border.enabled}`,
          },
        },
      },
    },
    // Card horizontal footer styles
    '& .MuiCardActions-root.horizontal-card': {
      paddingTop: idsTokens.card.default.spacing.footer.padding.top,
      paddingRight: idsTokens.card.default.spacing.footer.padding.right,
      paddingBottom: idsTokens.card.default.spacing.footer.padding.bottom,
      paddingLeft: idsTokens.card.default.spacing.footer.padding.left,
      marginLeft: 'unset',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
    },
  },
});
